import { Link } from 'react-router-dom';

import { PILOT_PLAN, PLANS, rupees, type LandingCopy, type LandingPlan } from './copy';

/** A plan's limits, the first lines on its card: orders a month, staff, retailers. */
const Limits = ({ plan, copy }: { plan: LandingPlan; copy: LandingCopy['pricing'] }) => (
  <>
    <li>{copy.ordersUpTo(plan.orders)}</li>
    <li>{copy.staffUpTo(plan.staff)}</li>
    <li>{copy.retailersUpTo(plan.retailers)}</li>
  </>
);

export const Pricing = ({
  copy,
  signup,
  linkProps,
}: {
  copy: LandingCopy['pricing'];
  signup: string;
  linkProps?: Record<string, () => void>;
}) => (
  <section id="pricing" className="lp-section">
    <div className="lp-container">
      <h2>{copy.title}</h2>
      <p className="lp-section__intro">{copy.intro}</p>
      <div className="lp-plans">
        <div className="lp-plan lp-plan--pilot">
          <span className="lp-plan__badge">{copy.startHere}</span>
          <h3>{copy.pilot.name}</h3>
          <p className="lp-plan__price">{copy.pilot.price}</p>
          <ul>
            <Limits plan={PILOT_PLAN} copy={copy} />
            {copy.pilot.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
          <Link to="/signup" className="lp-btn lp-btn--primary" {...linkProps}>
            {signup}
          </Link>
        </div>
        {PLANS.map((plan) => {
          const text = copy.plans[plan.key];
          return (
            <div key={plan.key} className="lp-plan">
              <h3>{text.name}</h3>
              <p className="lp-plan__price">
                {rupees(plan.price)}
                <span>{copy.perMonth}</span>
              </p>
              <ul>
                <Limits plan={plan} copy={copy} />
                {text.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <Link to="/signup" className="lp-btn lp-btn--outline" {...linkProps}>
                {copy.planCta}
              </Link>
            </div>
          );
        })}
      </div>
      <ul className="lp-plans__notes">
        {copy.notes.map((note) => (
          <li key={note}>{note}</li>
        ))}
      </ul>
    </div>
  </section>
);
